/**
 * 公共方法文件
  */
import ajax from './http';
const api = {
  getUserInfo: (params) => ajax.post('/api/v1/userInfo.json', params, ),
  // 错误统计获取所有url接口
  getErrorUrlList: (params) => ajax.get('/api/v1/error/distinctUrlList.json', params),
  // 错误统计获取折线图数据接口
  getErrorCountList: (params) => ajax.get('/api/v1/error/distinctUrlCountList.json', params),
  // 错误统计列表数据接口
  getErrorStatisticsList: (params) => ajax.post('/api/v1/error/statisticsList.json', params),
  // 错误日志接口
  errorLogList: (params) => ajax.post('/api/v1/error/log.json', params),
  // 获取时长list
  getStatisticsType: (params) => ajax.post('/api/v1/monitor/statistics/statisticsType.json', params),
  // 访问页面统计查询接口
  getSysList: (params) => ajax.post('/api/v1/monitor/project/select.json', params),
  // 访问页面统计查询接口
  getVisitInfo: (params) => ajax.post('/api/v1/monitor/statistics/visitInfo.json', params),
  // 访问页面统计详情
  getVisitInfoDetail: (params) => ajax.post(`/api/v1/visit/getVisitRequestInfoDetailStatistics?id=${params}`),
  // 性能详情表格
  getVisitPageInfo: (params) => ajax.post('/api/v1/visit/getVisitPageInfo', params),
  // 性能详情过滤条件
  getVisitScreen: (params) => ajax.post('/api/v1/visit/getVisitScreen', params),
  // 性能详情图表
  getVisitDetailStatistics: (params) => ajax.post('/api/v1/visit/getVisitDetailStatistics', params),
  // 性能详情导出
  getExportVisitDetail: (params) => ajax.get('/api/v1/visit/exportVisitDetail', params,{}, {responseType: 'blob'}),
  // 错误日志接口导出
  exportErrorLog: (params) => ajax.get('/api/v1/error/exportErrorLog', params, {}, {responseType: 'blob'}),
  // ajax异常调用接口
  ajaxErrorData: (params) => ajax.post('/api/v1/slow/ajaxError.json', params),
  // ajax调用接口
  ajaxTransferData: (params) => ajax.post('/api/v1/slow/ajaxPage.json', params),
  // ajax性能接口
  ajaxNatureData: (params) => ajax.post('/api/v1/slow/ajaxNature.json', params),
  // ajax 页面
  ajaxPageData: (params) => ajax.post('/api/v1/slow/ajaxReport.json', params),
  // 慢页面追踪
  slowPageData: (params) => ajax.post('/api/v1/visit/findVisitSlowByPage', params)
}
export default api;
